var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chatbot-selector" },
    [
      _vm.selectedStory
        ? _c(
            "Modal2",
            {
              attrs: {
                showTitle: true,
                title: _vm.$t("message.chatbotSettings"),
                showFooter: false,
                large: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.selectedStory = null
                },
              },
            },
            [
              _c("ForwardChatbotTunings", {
                attrs: { "default-story-id": _vm.selectedStory._id },
                on: {
                  cancel: function ($event) {
                    _vm.selectedStory = null
                  },
                  send: _vm.handleForward,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.stories.length === 0
        ? _c("div", { staticClass: "empty" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$st("mesage.chatbotScenarioNotFound"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.$t("message.noChatbotScenario"))),
            ]),
          ])
        : [
            _c(
              "div",
              { staticClass: "items" },
              [
                _vm.stories.length <= 0
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.$t("message.scenarioNotFound"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.stories, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item._id,
                      staticClass: "item-card",
                      class: {
                        selected: _vm.pointerIndex === index,
                        hoverSelected: _vm.pointerIndex === index,
                      },
                      attrs: { "data-id": item._id, "data-pointer": index },
                      on: {
                        click: function ($event) {
                          return _vm.selectStory(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "title-wrapper" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.title) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-preview" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              item.description ||
                                _vm.$t("message.descNotAvailable")
                            ) +
                            "\n                "
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }